import { apiFetch } from './client';

export type VerificationStatus = 'pending' | 'verified' | 'rejected';

export interface AdminUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'admin' | 'client' | 'deliverer' | 'business';
  phoneNumber?: string;
  isActive: boolean;
  verificationStatus: VerificationStatus;
  verificationDate?: string | null;
  verificationSubmissionDate?: string | null;
  verificationNotes?: string;
  createdAt: string;
}

export interface AdminUsersListResponse {
  success: true;
  data: AdminUser[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export interface AdminUsersListParams {
  page?: number;
  limit?: number;
  role?: 'admin' | 'client' | 'deliverer' | 'business';
  verificationStatus?: VerificationStatus;
  search?: string;
}

export const fetchAdminUsers = (params: AdminUsersListParams = {}) =>
  apiFetch<AdminUsersListResponse>('/api/v1/users', {
    query: params as Record<string, string | number | undefined | null>
  });

/** Admin valide ou rejette la vérification d'un utilisateur. */
export const reviewUserVerification = (
  userId: string,
  payload: { status: 'verified' | 'rejected'; notes?: string }
) =>
  apiFetch<{ success: true; data: { userId: string; verificationStatus: string; verificationDate: string | null } }>(
    `/api/v1/users/${userId}/verification-review`,
    { method: 'PATCH', body: payload }
  );
